var script = document.createElement('script');
 
// Set the script source to the jquery clientlib
script.src = "/etc.clientlibs/sunbeltrentals/clientlibs/clientlib-jquery.js";
 
// Set the script type (optional but good practice)
script.type = "text/javascript";
 
// Append the script to the <head> or <body> of the documentdocument.head.appendChild(script);
document.head.appendChild(script);